__webpack_require__.p = "https://gizmeon.mdc.akamaized.net/files/web/staging/Stratus/build-v1.0.5/";